module.exports = __webpack_public_path__ + "static/media/couch-removal.5d46ef43.svg";